export default {"src":"/_next/static/media/alert-success.78be1052.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};